import { initializeApp } from 'firebase/app';
import { getFirestore, initializeFirestore, persistentLocalCache, persistentMultipleTabManager, enableNetwork, disableNetwork } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';

const firebaseConfig = {
  // Use environment variables if available, otherwise fallback to default config
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyADHFFueiWLD-UNXxsTcPz8rbd3UmOin6Y",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "japacounter-72f8f.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "japacounter-72f8f",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "japacounter-72f8f.firebasestorage.app",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "633555912781",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:633555912781:web:437e737816e28605da7404",
  measurementId: "G-9NC97NS818"
};

// Check if Firebase is properly configured
const isFirebaseConfigured = () => {
  return firebaseConfig.apiKey && 
         firebaseConfig.projectId &&
         firebaseConfig.apiKey !== "demo-api-key";
};

// Initialize Firebase
let app;
let db;
let storage;
let auth;
let googleProvider;

try {
  app = initializeApp(firebaseConfig);
  
  // Initialize Firebase Auth
  auth = getAuth(app);
  
  // Initialize Google Auth Provider
  googleProvider = new GoogleAuthProvider();
  googleProvider.addScope('profile');
  googleProvider.addScope('email');
  
  // Initialize Firestore with persistent local cache (includes offline support)
  if (isFirebaseConfigured()) {
    db = initializeFirestore(app, {
      localCache: persistentLocalCache({
        tabManager: persistentMultipleTabManager()
      })
    });
    console.log('✅ Firebase initialized with offline persistence');
  } else {
    db = getFirestore(app);
    console.warn('⚠️ Firebase is not properly configured. Please check your Firebase credentials.');
  }
  
  storage = getStorage(app);
} catch (error) {
  console.error('💥 Firebase initialization error:', error);
  // Fallback to default Firestore if the new cache fails
  db = getFirestore(app);
  auth = getAuth(app);
  googleProvider = new GoogleAuthProvider();
  console.log('⚠️ Using fallback Firebase configuration');
}

// Network state management
const goOffline = () => {
  console.log('📴 Going offline...');
  return disableNetwork(db);
};

const goOnline = () => {
  console.log('🌐 Going online...');
  return enableNetwork(db);
};

// Network status checker
const checkNetworkStatus = () => {
  return navigator.onLine;
};

// Auto-reconnect when network comes back
if (typeof window !== 'undefined') {
  window.addEventListener('online', () => {
    console.log('🌐 Network connected - re-enabling Firestore');
    goOnline().catch(error => {
      console.error('❌ Failed to re-enable network:', error);
    });
  });

  window.addEventListener('offline', () => {
    console.log('📴 Network disconnected - Firestore will work offline with cached data');
  });
}

export { db, storage, auth, googleProvider, isFirebaseConfigured, goOffline, goOnline, checkNetworkStatus }; 